import * as NameSpace from 'src/store/NameSpace'
import { ParseService } from '../../Services/parse'
// import { cloneDeep } from 'lodash'
// import { zoneTableDataSchema } from 'src/components/pop-up/mock'
// import { zoneTableHeaderSchema } from 'src/components/pop-up/zoneSchema'
// import { FlexTable } from 'src/components/shared/flexTables'

const state = {
  [NameSpace.STATE_ZONE_SALE_PRICES]: {
    data: null,
    headers: null,
    error: null,
    showAgain: false,
    showModal: false
  }
}

const getters = {
  [NameSpace.GET_ZONE_SALE_PRICES]: state => {
    return state[NameSpace.STATE_ZONE_SALE_PRICES]
  }
}

const mutations = {
  [NameSpace.MUTATE_ZONE_SALE_PRICES]: (state, payload) => {
    state[NameSpace.STATE_ZONE_SALE_PRICES] = payload
  }
}

const actions = {
  // [NameSpace.ACTION_FETCH_ZONE_SALE_PRICES]: ({ commit }, payload) => {
  //   ParseService.getApproveOffers({})
  //   .then(approveResult => {
  //     let tableInstance = new FlexTable(approveResult.header, approveResult.data, 0)
  //     const resultHeader = tableInstance.getObjectTableHeaders(approveResult.header, 'Zone Id')
  //     let tableHeadersString = tableInstance.getStringTableHeaders(approveResult.header)
  //     const editableHeader = tableInstance.getIndexforFillteredTableHeaders(approveResult.header, 'makeEditable')
  //     const tableData = tableInstance.getCellDataAsObject(tableHeadersString, approveResult.data, 'makeEditable', 'set_zone', 100, editableHeader)
  //     // console.log('ACTION_FETCH_ZONE_SALE_PRICES', tableData)
  //     // var index = resultHeader.indexOf('Zone Id')
  //     // resultHeader.splice(index, 1)
  //     // const resultData = tableInstance.getHorizontalTableData(zoneTableHeaderSchema, zoneTableDataSchema, 'makeEditable')
  //     let zoneIdIndex = tableHeadersString.indexOf('Zone Id')
  //     console.log(zoneIdIndex)
  //     for (let array of tableData) {
  //       array.splice(0, 1)
  //     }
  //     console.log('ACTION_FETCH_ZONE_SALE_PRICES', tableData)
  //     let result = {
  //       header: resultHeader,
  //       data: tableData
  //     }
  //     commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
  //       data: result,
  //       error: null
  //     })
  //     .catch(error => {
  //       commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
  //         data: error,
  //         error: null
  //       })
  //     })
  //   })
  // },
  [NameSpace.SET_ZONE_STATE]: ({ commit }, payload) => {
    if (payload === null) {
      commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
        data: null,
        headers: null,
        error: null,
        showAgain: false,
        showModal: false
      })
    } else {
      console.log('SET_ZONE_STATE', payload)
      commit(NameSpace.MUTATE_ZONE_SALE_PRICES, payload)
    }
    // setTimeout(() => {
    //   commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
    //     data: null,
    //     error: null,
    //     showAgain: false
    //   })
    // }, 20000)
  },
  [NameSpace.UPDATE_ZONE_STATE]: ({ commit }, payload) => {
    ParseService.updateZonePrices({data: payload.data})
      .then(result => {
        let myData = state[NameSpace.STATE_ZONE_SALE_PRICES].data
        let myHeaders = state[NameSpace.STATE_ZONE_SALE_PRICES].headers
        if (result && result.success) {
          commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
            data: myData,
            headers: myHeaders,
            error: null,
            showAgain: false,
            showModal: true
          })
        } else {
          commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
            data: payload.original,
            headers: myHeaders,
            showAgain: false,
            showModal: true,
            error: result
          })
        }
      })
      .catch(error => {
        let myHeaders = state[NameSpace.STATE_ZONE_SALE_PRICES].headers
        commit(NameSpace.MUTATE_ZONE_SALE_PRICES, {
          data: null,
          headers: myHeaders,
          error: error,
          showAgain: false,
          showModal: true
        })
      })
  }
}

// function setUpZonePriceData (approveResult) {
//   let tableInstance = new FlexTable(approveResult.header, approveResult.data, 0)
//   const resultHeader = tableInstance.getObjectTableHeaders(approveResult.header, 'Zone Id')
//   let tableHeadersString = tableInstance.getStringTableHeaders(approveResult.header)
//   const editableHeader = tableInstance.getIndexforFillteredTableHeaders(approveResult.header, 'makeEditable')
//   const tableData = tableInstance.getCellDataAsObject(tableHeadersString, approveResult.data, 'makeEditable', 'set_zone', 100, editableHeader)
//   for (let array of tableData) {
//     array.splice(0, 1)
//   }
//   let result = {
//     header: resultHeader,
//     data: tableData,
//     showModal: true
//   }
//   return result
// }

export default {
  state,
  getters,
  mutations,
  actions
}



// WEBPACK FOOTER //
// ./src/store/modules/zonePriceEdit.js